import { Component, signal, Input, WritableSignal, effect, ViewChild,computed, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table,TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { TableRow, TableColumn } from '../../../../../shared/models/components/tables/table.models';
import { ValueFormatPipe} from '../../../../../shared/pipes/value-format.pipe';

@Component({
    selector: 'app-results-table',
    imports: [CommonModule, TableModule, FormsModule, ValueFormatPipe],
    templateUrl: './results-table.component.html',
    styleUrl: './results-table.component.scss'
})
export class ResultsTableComponent {
 @Input() columnsResults!: WritableSignal<TableColumn[]>;
 @Input() rowsResults!: WritableSignal<TableRow[]>;
 @Input() usePagination: boolean = false;
 @Input() rowsPerPage: number = 10; // Valor predeterminado

 @ViewChild('dt', { static: false }) dt!: Table;
 readonly watchedRows = computed(()=> this.rowsResults())
 constructor() {
    effect(() => {
      const rows = this.watchedRows();
        const _ = this.columnsResults();
        if (this.dt) {
          this.dt.reset();
        }
       });
  }

  
    
  

}